import React, { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { View } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

const ParagraphVacanciesOverview: React.FC<HTMLAttributes<HTMLDivElement>> = () => {
  const { t } = useTranslation();

  return (
    <div className="Paragraph ParagraphVacanciesOverview">
      <Container>
        <h2 className="visually-hidden">{t('content_types.vacancy.subheading')}</h2>
        <View
          id="vacancies"
          display="default"
        />
      </Container>
    </div>
  );
};

export default ParagraphVacanciesOverview;
